export enum CallState {
  Closed = 'closed',
  Connecting = 'connecting',
  Open = 'open',
  Pending = 'pending',
  Reconnecting = 'reconnecting',
  Ringing = 'ringing',
}
